export var SET_TOKEN = "LOGIN/SET_TOKEN";
export var LOGOUT = "LOGIN/LOGOUT";